import { Property } from 'csstype'

export type ClickAndCollectModalThemeInterface = {
  width?: Property.Width
}

export const theme: ClickAndCollectModalThemeInterface = {
  width: 'max-content',
}
